/** Coordenadas dentro de la Marina Alta / entorno habitual del CRM. */
export function coordsEnMarinaAlta(lat, lng) {
  const la = Number(lat);
  const ln = Number(lng);
  return (
    Number.isFinite(la)
    && Number.isFinite(ln)
    && la >= 38.35
    && la <= 39.25
    && ln >= -0.35
    && ln <= 0.55
  );
}

export const CENTRO_DENIA = { lat: 38.84084, lng: 0.10569 };
